import styled from 'styled-components'

interface DrawerProps {
  open: boolean;
  id?: string;
}

export const DrawerContainer = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  width: ${props => props.open ? '100vw' : '0'};
  height: 100vh;
  transition: 0.3s;
`

export const Drawer = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  width: ${props => props.open ? '50%' : '0'};
  min-width: ${props => props.open ? '400px' : '0'};
  max-width: ${props => props.open ? '800px' : '0'};
  height: 100vh;
  background: #FFFFFF;
  border: ${props => props.open ? '4px solid #C8C8C8' : 'none'};
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: ${props => props.open ? '40px' : '0'};
  transition: 0.3s;
`

export const CloseButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  & svg {
    height: 28.8px;
    width: 28.8px;
  }
`

export const DrawerContent = styled.div`
  width: 100%; 
  height: 100%; 
  overflow: hidden;
`